// extracted by mini-css-extract-plugin
export default {"container":"YY-z","title":"ZY-z","link":"_Y-z"};